import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["actionSubjectId"];
import React, { forwardRef } from 'react';
import { UIAnalyticsEvent, useAnalyticsEvents } from '@atlaskit/analytics-next';
import AkButton from '@atlaskit/button';
import { ANALYTICS_CHANNEL } from '../../../common/constants';
import createEventPayload from '../../../common/utils/analytics/analytics.codegen';
export var Button = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var actionSubjectId = _ref.actionSubjectId,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  return /*#__PURE__*/React.createElement(AkButton, _extends({}, props, {
    ref: ref,
    onClick: function onClick(event) {
      var _props$onClick;
      var payload = createEventPayload("ui.button.clicked.".concat(actionSubjectId), {});
      var analyticEvent = createAnalyticsEvent(payload);
      var cloned = analyticEvent.clone();
      analyticEvent.fire(ANALYTICS_CHANNEL);
      (_props$onClick = props.onClick) === null || _props$onClick === void 0 || _props$onClick.call(props, event, cloned !== null && cloned !== void 0 ? cloned : new UIAnalyticsEvent({
        payload: payload
      }));
    }
  }));
});